export const LOOKER_DATE_RANGES = {
  YESTERDAY: '1 day ago for 1 day',
  LAST_7_DAYS: '7 days ago for 7 days',
  LAST_2_WEEKS: '14 days ago for 14 days',
  LAST_30_DAYS: '30 days ago for 30 days',
  LAST_60_DAYS: '60 days ago for 60 days',
  LAST_90_DAYS: '90 days ago for 90 days',
  LAST_180_DAYS: '180 days ago for 180 days',
  LAST_365_DAYS: '365 days ago for 365 days',
} as const;

export const DEFAULT_DATE_FILTER = '7 days ago for 7 days';

export const dashboardID = 'hcp365_v2_site_view_app::hcp365_site_view';

export const MAX_TABLE_ROWS = 100;

export const FILTER_NAME = 'day';
export const DEFAULT_OPTION: DateRangeOption = LOOKER_DATE_RANGES.LAST_7_DAYS;

export type DateRangeOption = (typeof LOOKER_DATE_RANGES)[keyof typeof LOOKER_DATE_RANGES] | 'custom';

export const DATE_RANGE_OPTIONS: Array<{ value: DateRangeOption; label: string }> = [
  { value: LOOKER_DATE_RANGES.YESTERDAY, label: 'Yesterday' },
  { value: LOOKER_DATE_RANGES.LAST_7_DAYS, label: 'Last 7 Days' },
  { value: LOOKER_DATE_RANGES.LAST_30_DAYS, label: 'Last 30 Days' },
  { value: LOOKER_DATE_RANGES.LAST_90_DAYS, label: 'Last 90 Days' },
  { value: LOOKER_DATE_RANGES.LAST_365_DAYS, label: 'Last 1 Year' },
  { value: 'custom', label: 'Custom' },
];
